// This is a COPY of downread/shared/src/utils/default-icon.ts. To modify, edit the original and then run downread/bin/build-shared.sh
// Helper for the generated default feed icons. The actual SVGs are produced
// and uploaded once by downread/bin/create-default-icons.ts to the
// downread-app-prod bucket under static/default-icons/, served from
// https://feeds.downread.com/static/default-icons/.

export const DEFAULT_ICON_BASE_URL = 'https://feeds.downread.com/static/default-icons/';

/**
 * Returns the CDN URL of the default icon for a feed without a favicon/image.
 * The glyph is the first letter/digit of the feed name (lower-cased); the
 * color is feedName.length % 10 (matching the 10 generated color variants).
 */
export function getDefaultIconUrl(feedName: string): string {
  const name = feedName || '';
  const match = name.match(/[a-z0-9]/i);
  const char = (match ? match[0] : 'a').toLowerCase();
  const color = name.length % 10;
  return `${DEFAULT_ICON_BASE_URL}${char}-${color}.svg`;
}
